import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
// React Bootstrap
import { Form, Button, Col, Accordion, Card } from "react-bootstrap";

const FormActividades = ({ defaultValues, submissionHandler, objActividades }) => {
  const [validated] = useState(false);
  const { register, handleSubmit } = useForm({
    defaultValues: defaultValues,
  });

  // Función que genera el objeto que necesita la petición para añadir o eliminar ingresos
  const getObjIngresosSubmit = (misActividades) => {
    const obj = {
      actividadAdd: [],
      actividadRemove: [],
    };
    Object.keys(objActividades).forEach((tipo) => {
      if (misActividades[tipo]) {
        obj.actividadAdd.push(tipo);
      } else {
        obj.actividadRemove.push(tipo);
      }
    });
    return obj;
  };

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(getObjIngresosSubmit(data));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      {Object.keys(objActividades).length && (
        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Actividades
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                {Object.keys(objActividades).map((tipo) => (
                  <Form.Group key={tipo} as={Col} xs={12} md controlId={tipo + "-datosEconomicos"}>
                    <Form.Check
                      custom
                      label={objActividades[tipo]}
                      name={tipo}
                      key={tipo}
                      defaultChecked={defaultValues?.length && defaultValues.find((f) => f.type === tipo)}
                      {...register(tipo, {})}
                    />
                  </Form.Group>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormActividades;
